import Reveal from "@/components/feature/Reveal";
import Breadcrumb from "@/components/feature/Breadcrumb";

/**
 * 法務・案内系ページ共通の PAGE HERO。
 * 画像は使わず、英字ラベル・ページタイトル・短い説明のみのシンプルなテキスト型。
 * 背景は既存サイトの warm white（background-100）を使用する。
 */
export default function LegalHero({
  path,
  en,
  h1,
  lead,
  sub,
}: {
  path: string;
  en: string;
  h1: string;
  lead: string;
  sub?: string;
}) {
  return (
    <section className="border-b border-background-300/70 bg-background-100 pb-14 pt-28 md:pb-16 md:pt-36 lg:pb-20 lg:pt-40">
      <div className="u-container">
        {/* 法務・案内系：HOME ＞ 現在ページ（現在ページは非リンク） */}
        <Breadcrumb
          items={[
            { label: "HOME", href: "/", path: "/" },
            { label: h1, path },
          ]}
        />

        <Reveal delay={80}>
          <div className="mt-10 md:mt-14">
            <span className="en-eyebrow block text-[11px] text-secondary-700 md:text-[12px]">{en}</span>
            <span className="mt-5 block h-px w-12 bg-accent-500" />
            <h1 className="mt-7 font-heading text-[30px] leading-[1.5] tracking-[0.02em] text-foreground-950 md:text-[42px]">
              {h1}
            </h1>
            <p className="mt-6 max-w-2xl text-[13px] leading-[2.2] text-foreground-700 md:text-[15px] whitespace-pre-line">
              {lead}
            </p>
            {sub ? (
              <p className="mt-4 max-w-2xl text-[13px] leading-[2.2] text-foreground-600 md:text-sm">{sub}</p>
            ) : null}
          </div>
        </Reveal>
      </div>
    </section>
  );
}